import { render } from "./PointsRecharge.vue?vue&type=template&id=456bc18e&scoped=true"
import script from "./PointsRecharge.vue?vue&type=script&lang=js"
export * from "./PointsRecharge.vue?vue&type=script&lang=js"

import "./PointsRecharge.vue?vue&type=style&index=0&id=456bc18e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456bc18e"]])

export default __exports__